/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="saleProgram.module.ts" />

module Meevo.Plugins.SaleProgram {
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import ISearchColumn = Meevo.Model.ISearchColumn;

    class SaleProgramController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
        public displayNameColumnsCustom: ISearchColumn;
        public coColumnsCustom: Array<ISearchColumn>;
        public objectState;

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',
            '$translate',
            '$sce'
        ];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: any,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected $translate: angular.translate.ITranslateService,
            protected $sce: ng.ISCEService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.coColumnsCustom = [
                { header: this.$translate.instant('LABEL_DATE_RANGE'), fieldName: 'dateRange', sortDirection: null, width: 25 },
                { header: "Owned By", fieldName: 'OwnedByLocationName', sortDirection: null, width: 35 },
                { header: "Located At", fieldName: 'AtLocationName', sortDirection: null, width: 35 },
                { header: "Status", fieldName: 'ObjectState', sortDirection: null, width: 15 },
            ];

            this.objectState = ObjectStateEnum;
        }

        /**
         * Creates the context for editing/adding an item.
         * @return {}
         */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.REGISTER_SALEPROGRAM).then(() => {
                this.busyService.stop();
                this.context = new SaleProgramContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.$translate,
                    this.$sce);
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
            }).finally(() => {
                this.busyService.stop();
            });
        }

        preSearchCallback(criteria, rootCriteria) {
            rootCriteria["SortBy"] = "DateCreated";
            rootCriteria["SortDirection"] = "Descending";
        }
    }

    angular.module("meevo.plugins.saleProgram")
        .controller("meevo.plugins.saleProgram.SaleProgramController", SaleProgramController);
}